<template>
    <access-denied v-if="accessDenied" title="atendimento" />
    <div class="page" v-else>
        <loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow" v-else>
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t('atendimento') }}
                        <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                            <b-icon
                                v-if="!hide.infoIsHidden"
                                icon="eye-off-outline"
                                type="is-danger"
                            />
                            <b-icon v-if="hide.infoIsHidden" icon="eye-outline" type="is-success" />
                        </a>
                    </h1>
                    <nav class="breadcrumb" aria-label="breadcrumbs" v-if="cameFrom == 'route'">
                        <ul>
                            <li>
                                <a class="a-inativo">{{ $t('vendas') }}</a>
                            </li>
                            <li>
                                <a class="a-inativo">{{ $t('crm') }}</a>
                            </li>
                            <li>
                                <a @click="$router.push({ name: 'ven-atendimento' })">{{
                                    $t('atendimento')
                                }}</a>
                            </li>
                            <li>
                                <a aria-current="page">{{
                                    idAtendimento ? idAtendimento : $t('novo')
                                }}</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="header-buttons">
                    <template v-if="isUpdate && permissao.export">
                        <div
                            v-if="exportacaoTipo != null && exportacaoTipo.exportapdf == 1"
                            class="export-icon is-clickable"
                            @click="checkExport('pdf')"
                        >
                            <b-icon 
                                icon="file-pdf" 
                                size="is-medium" 
                                class="is-medium" 
                                v-tippy 
                                :title="$t('msg-tooltip-pdf')"
                            />
                        </div>
                        <div
                            v-if="exportacaoTipo != null && exportacaoTipo.exportaexcel == 1"
                            class="export-icon is-clickable"
                            @click="checkExport('excel')"
                        >
                            <b-icon 
                                icon="file-excel" 
                                size="is-medium" 
                                class="is-medium" 
                                v-tippy 
                                :title="$t('msg-tooltip-excel')"
                            />
                        </div>
                        <div
                            v-if="exportacaoTipo != null && exportacaoTipo.exportacsv == 1"
                            class="export-icon is-clickable"
                            @click="checkExport('csv')"
                        >
                            <b-icon 
                                icon="file" 
                                size="is-medium" 
                                class="is-medium" 
                                v-tippy 
                                :title="$t('msg-tooltip-csv')"
                            />
                        </div>
                    </template>
                    <button class="delete-btn" type="button" tag="button" @click="redirectToList">
                        {{ $t('voltar') }}
                    </button>
                </div>
            </div>

            <ul class="nav nav-tabs nav-tabs-children" v-if="isUpdate">
                <li
                    v-for="(aba, i) in abas"
                    :key="i"
                    v-show="permissao.read"
                    :class="{ active: abaSelecionada == i }"
                    @click="changeTab(i)"
                >
                    <a data-toggle="tab">{{ $t(aba) }}</a>
                </li>
            </ul>
            <b-dropdown aria-role="list" class="mobile-tab-list">
                <div slot="trigger" class="mobile-tab">
                    <span class="mobile-tab-text">
                        {{ $t(abas[abaSelecionada]) }}
                    </span>
                    <em class="mdi mdi-chevron-down"></em>
                </div>

                <b-dropdown-item
                    class="mobile-tab-list-item"
                    :class="{ active: abaSelecionada == i }"
                    aria-role="listitem"
                    v-for="(aba, i) in abas"
                    v-show="permissao.read"
                    :key="i"
                    @click="changeTab(i)"
                >
                    {{ $t(aba) }}
                </b-dropdown-item>
            </b-dropdown>
            <Geral
                ref="tabGeral"
                v-if="abasAbertas['geral'] && permissao.read"
                v-show="abas[abaSelecionada] == 'geral'"
                :isUpdate="isUpdate"
                :uuidFrom="uuidFrom"
                :cameFrom="cameFrom"
                :reloadData="reloadData"
                :lengthFotos="lengthFotos"
                :lengthFormularios="lengthFormularios"
                @lengthFotos="lengthFotos = $event"
                @lengthFormularios="lengthFormularios = $event"
                @idAtendimento="idAtendimento = $event"
                @idEmpresa="idEmpresa = $event"
                @idMotivoAtendimento="idMotivoAtendimento = $event"
                @changeTab="changeTab"
                @saved="reloadChild"
                @isChanged="
                    isChanged = $event;
                    $emit('isChanged', $event);
                "
                @redirect="redirectToList"
                @minimoFotos="minimoFotos = $event"
                @situacao="situacao = $event"
                @checks="checks = $event"
            />
            <Fotos
                ref="tabFotos"
                v-if="abasAbertas['fotos'] && permissao.read && isUpdate"
                v-show="abas[abaSelecionada] == 'fotos'"
                :uuidFrom="uuidFrom"
                :isUpdate="isUpdate"
                :minimoFotos="minimoFotos"
                :situacao="situacao"
                @saved="$emit('saved', null)"
                @lengthFotos="lengthFotos = $event"
                @isChanged="
                    isChanged = $event;
                    $emit('isChanged', $event);
                "
            />
            <Formulario
                ref="tabFormulario"
                v-if="abasAbertas['formulario'] && permissao.read && idMotivoAtendimento > 0 && paginaFormularioAtiva === 'Formulario'"
                v-show="abas[abaSelecionada] == 'formulario'"
                :situacaoAtendimento="situacao"
                :uuidFrom="uuidFrom"
                :idMotivoAtendimento="idMotivoAtendimento"
                @changeTab="changeTab"
                @isChanged="
                    isChanged = $event;
                    $emit('isChanged', $event);"
                @formulario="formulario = $event"
                @mostrarFormAnswer="paginaFormularioAtiva = 'FormAnswer'"
                @lengthFormularios="lengthFormularios = $event"
            />
            <FormAnswer
                ref="tabFormulario"
                v-if="abasAbertas['formulario'] && permissao.read && paginaFormularioAtiva === 'FormAnswer'"
                v-show="abas[abaSelecionada] == 'formulario'"
                :situacaoAtendimento="situacao"
                :uuidFrom="uuidFrom"
                :idMotivoAtendimento="idMotivoAtendimento"
                :formularioCameFromList="formulario"
                :idEmpresa="idEmpresa"
                @changeTab="changeTab"
                @isChanged="
                    isChanged = $event;
                    $emit('isChanged', $event);"
                @mostrarFormulario="
                    formulario = null;
                    paginaFormularioAtiva = 'Formulario';
                "
            />
        </div>
        <lateral-content
            compact
            footer
            header
            headerHideClose
            :title="$t('exportacao-dados')"
        >
            <div class="bg p-3">
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-12">
                            {{ $t('title-exp') }}
                        </div>
                        <div class="column is-12">
                            <v-input
                                ref="tituloExportacao"
                                v-model="tituloExportacao"
                                :maxlength="100"
                                title="titulo-exp"
                                required
                                :invalid="tituloExportacao == null"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <template v-slot:footer-right="{  }">
                <b-button type="is-primary" icon-right="filter" @click="saveExportacao()">
                    {{ $t('exportar-rel') }}
                </b-button>
            </template>
        </lateral-content>
    </div>
</template>

<script>
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';
import AtendimentoValidation from '@/services/validations/AtendimentoValidation.js';
import ExportacaoTipoService from '@/services/ExportacaoTipoService.js';
import ExportacaoService from '@/services/ExportacaoService.js';
import ExportacaoLogService from '@/services/ExportacaoLogService.js';
import ExportacaoDadosService from '@/services/ExportacaoDadosService.js';

// Abas
import Geral from '@/components/vendas/atendimento/abas/Geral.vue';
import Fotos from '@/components/vendas/atendimento/abas/Fotos.vue';
import Formulario from '@/components/vendas/atendimento/abas/Formulario.vue';
import FormAnswer from '@/components/vendas/atendimento/abas/FormAnswer.vue';

export default {
    name: 'AtendimentoManage',

    components: {
        HideInfo,
        Geral,
        Fotos,
        Formulario,
        FormAnswer,
    },
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        uuidFrom: {
            type: String,
            defult: null,
        },
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            abaSelecionada: 0,
            abas: ['geral', 'fotos', 'formulario'],
            validation: new AtendimentoValidation(this.$root.msgs),
            exportacaoTipoService: new ExportacaoTipoService(this.$http, this.$router),
            exportacaoService: new ExportacaoService(this.$http, this.$router),
            exportacaoLogService: new ExportacaoLogService(this.$http, this.$router),
            exportacaoDadosService: new ExportacaoDadosService(this.$http, this.$router),
            abasAbertas: {},
            formulario: null,
            permissao: false,
            accessDenied: false,
            situacao: 0,
            isEnable: false,
            checks: null,
            idAtendimento: 0,
            idMotivoAtendimento: 0,
            idEmpresa: 0,
            isChanged: false,
            isUpdate: false,
            isLoading: false,
            // Expostação
            exportacaoTipo: null,
            exportWithPhoto: false,
            tituloExportacao: null,
            paginaFormularioAtiva: 'Formulario',
            minimoFotos: 0,
            lengthFotos: 0,
            lengthFormularios: 0,
        };
    },
    mounted() {
        if (this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
    },
    created() {
        if (this.uuidFrom != null) this.isUpdate = true;

        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-atendimento');

        if (
            (!this.isUpdate && !this.permissao.create)
            ||
            (this.isUpdate && !this.permissao.read)
        ) {
            this.accessDenied = true;
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'atendimento' },
            });
        } else {
            this.abasAbertas['geral'] = true;
            if (this.isUpdate) this.carregaExportacaoTipo();
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    watch: {
        uuidFrom(val, old) {
            if (old == null && val != null) {
                this.isLoading = true;
                this.isUpdate = true;
                setTimeout(() => {
                    this.isLoading = false;
                }, 500);
            }
            this.carregaExportacaoTipo();
        },
        formulario :{
            deep: true,
            handler: function () {
                if (this.formulario != null) {
                    this.paginaFormularioAtiva = 'FormAnswer'
                }
            }
        },
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        redirectToList() {
            if (this.isChanged) {
                this.$root.confirm({
                    message: this.$t('msg-tem-certeza-alteracoes'),
                    onConfirm: (_) => {
                        this.$emit('voltar', true);
                    },
                    onCancel: (_) => {
                        return;
                    },
                });
            } else {
                this.$emit('voltar', true);
            }
        },
        reloadChild(uuid) {
            if (this.isUpdate) {
                this.$emit('saved', uuid);
            } else {
                this.$emit('redirectToEdit', uuid);
            }
        },
        // Carrega os tipos de exportações disponiveis para essa tela
        carregaExportacaoTipo() {
            // Inidica qual a tela que será passada (ENUM ExportacaoTelas) para realizar a busca
            this.exportacaoTipoService.findByTela('CRM_ATENDIMENTO').then((body) => {
                if (body.content) {
                    this.exportacaoTipo = body.content;
                }
            });
        },
        checkExport(tipo) {
            this.exportWithPhoto = false;
            this.tipoExportacao = tipo;

            this.gerarArquivoExportacao();
        },
        gerarArquivoExportacao() {
            this.isSaving = true;
            this.isLoading = true;

            const exportacaoAtendimento = {
                exportacao: {
                    usuario: {
                        idusuarioerp: this.$store.state.user.idusuarioerp,
                    }
                },
                exportafoto: this.exportWithPhoto,
                usuario: this.$store.state.user,
            };

            this.exportacaoDadosService
                .saveAtendimento(
                    exportacaoAtendimento, 
                    this.tipoExportacao, 
                    this.uuidFrom, 
                    true
                )
                .then(({content}) => {
                    this.getArchive(content);
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-exp-gerar');
                })
        },
        getArchive(url) {
            this.exportacaoService.downloadArchive(url)
            .then((r) => {
                const prefix = this.tipoExportacao === "pdf" ? 'application' : 'text'

                const blob = new Blob([r.data], { type: `${prefix}/${this.tipoExportacao}` });

                const fileURL = window.URL.createObjectURL(blob);

                window.open(fileURL, '_blank');

                window.URL.revokeObjectURL(blob);
            })
            .catch((e) => {
                this.$root.showMessage('error', 'msg-erro-exp-gerar');
            })
            .finally((_) => {
                this.isSaving = false;
                this.isLoading = false;
            });
        }
    },
};
</script>
<style lang="scss" scoped>
.page {
    position: relative;

    .export-icon {
        color: var(--primary-color);
        padding-right: 5px;
    }
    .nav-tabs-children {
        margin-bottom: 20px;
        li > ::after {
            bottom: -4px;
            border-width: 2px;
        }
    }
    .mobile-tab {
        cursor: pointer;

        &-list {
            width: calc(100% + 40px);
            margin-top: 20px;
            margin-bottom: 20px;
            margin-left: -20px;
            padding-right: 20px;
            padding-bottom: 5px;
            padding-left: 20px;
            border-bottom: 1px solid $table-border;
            justify-content: center;

            &::after {
                content: '';
                border: 3px solid $primary-color-click;
                border-radius: 100px;
                position: absolute;
                width: calc(100% - 40px);
                bottom: -3px;
            }

            &-item {
                text-transform: uppercase;
                font-weight: 600;
                color: $text-color;

                &.active {
                    color: $primary-color-click;
                }
            }
        }

        &-text {
            text-transform: uppercase;
            font-weight: 600;
            color: $primary-color-click;

            & ~ i {
                color: $primary-color-click;
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
